import { Group, Text, ActionIcon } from '@mantine/core';
import { X } from 'lucide-react';
import classes from './DataLibraryDrawer.module.css';

interface DataLibraryHeaderProps {
  onClose?: () => void;
}

export function DataLibraryHeader({ onClose }: DataLibraryHeaderProps) {
  return (
    <Group className={classes.header} justify="space-between" px="md" py="sm">
      <Text fw={700} size="lg" c="white">
        Data Library
      </Text>
      {onClose && (
        <ActionIcon variant="subtle" color="white" onClick={onClose} aria-label="Close">
          <X size={20} />
        </ActionIcon>
      )}
    </Group>
  );
}
